import React from 'react'

import { useRoot } from '../../app/useRoot'
import { useMapPanning } from '../../components/Map/useMapPanning'
import { useQInitialDeliveryLocation } from '../../graph/generated'

type TProps = NoChildren

export const DeliveryInitialLocation: React.FC<TProps> = props => {
  const { location } = useRoot()

  const { data } = useQInitialDeliveryLocation(
    {},
    { fetchPolicy: 'cache-first', skip: location.hasLocation },
  )

  const panToGps = useMapPanning()

  React.useEffect(() => {
    if (!location.hasLocation && data) {
      const gps = data.location.gpsCoordinates
      if (gps) {
        panToGps(gps)
      }
    }
  })

  return null
}
